"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    AVAILABLE: 'AVAILABLE',
    SEEKING_HOURS: 'SEEKING_HOURS',
    FULL: 'FULL',
    RESIGNED: 'RESIGNED',
    ONBOARDING: 'ONBOARDING',
};
//# sourceMappingURL=tutorCapacity.js.map